import { Button } from "components/ui/v2";
import { useMutation } from "@apollo/client";
import SVG from "components/SVG";
import { gqlUser } from "gql";
import {
  ISocialNetworkLogInInput,
  ISocialNetworkLogInRes
} from "gql/User/mutations";
import { ILoginResponse } from "gql/User/queries";
import useTranslation from "next-translate/useTranslation";
import { useLinkedIn } from "react-linkedin-login-oauth2";

interface ILinkedInButtonProps {
  parentLoading?: boolean;
  onCompleted: (loginWithLinkedin: ILoginResponse) => void;
}

const LinkedInButtonAurora = (props: ILinkedInButtonProps) => {
  const { onCompleted, parentLoading } = props;
  const [loginWithLinkedin, { loading }] = useMutation<
    { loginWithLinkedIn: ISocialNetworkLogInRes },
    { linkedinLogInInput: ISocialNetworkLogInInput }
  >(gqlUser.mutations.LOGIN_WITH_LINKEDIN, {
    onCompleted: ({ loginWithLinkedIn }) => {
      onCompleted(loginWithLinkedIn);
    }
  });
  const { t } = useTranslation("common");
  const { linkedInLogin } = useLinkedIn({
    clientId: process.env.NEXT_PUBLIC_LINKEDIN_CLIENTID || "",
    redirectUri: `${
      typeof window === "object" && window.location.origin
    }/linkedin`,
    scope: "r_emailaddress r_liteprofile",
    onSuccess: async (code) => {
      loginWithLinkedin({
        variables: {
          linkedinLogInInput: {
            accessToken: code
          }
        }
      });
    },
    onError: () => {}
  });

  return (
    <Button
      type="button"
      variant="outline"
      width="full"
      size="sm"
      onClick={linkedInLogin}
      loading={loading}
      disabled={parentLoading}
      leftIcon={<SVG src="/icon/linkedin.svg" width={18} height={18} />}
    >
      {t("Ingresar con LinkedIn")}
    </Button>
  );
};

export default LinkedInButtonAurora;
